(function () {
  'use strict';

  var KEY = 'chill-cookie-consent';
  var bar = document.getElementById('chill-cookie-bar');
  if (!bar) return;

  // Already decided — never show again.
  if (localStorage.getItem(KEY)) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show() {
    bar.hidden = false;
    if (reduced) {
      bar.classList.add('is-visible');
    } else {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bar.classList.add('is-visible');
        });
      });
    }
  }

  function dismiss() {
    bar.classList.remove('is-visible');
    if (reduced) {
      bar.hidden = true;
    } else {
      bar.addEventListener('transitionend', function () {
        bar.hidden = true;
      }, { once: true });
    }
  }

  document.getElementById('chill-cookie-accept').addEventListener('click', function () {
    localStorage.setItem(KEY, 'accepted');
    dismiss();
  });

  document.getElementById('chill-cookie-decline').addEventListener('click', function () {
    localStorage.setItem(KEY, 'declined');
    dismiss();
  });

  // Show after a short delay so it doesn't compete with page load.
  setTimeout(show, 1200);
})();
